import { OPERATIONAL_REMARK_ADDITIONAL_DETAILS_KEY } from 'constants/booking';

export const getDefaultTab = (location) => {
  if (!location.hash) {
    return null;
  }

  const tab = location.hash.substring(1);

  if (tab !== 'notes' && tab !== 'history' && tab !== 'dates' && tab !== 'salesforce') {
    return null;
  }

  return tab;
};

export const getOperationalRemark = (additionalDetails = []) => {
  const operationalRemark = additionalDetails?.find((ad) => ad.key === OPERATIONAL_REMARK_ADDITIONAL_DETAILS_KEY);

  return operationalRemark ? operationalRemark.value : null;
};
